import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=677ec0dc&scoped=true"
import script from "./ContentDetails.vue?vue&type=script&lang=js"
export * from "./ContentDetails.vue?vue&type=script&lang=js"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=677ec0dc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ec0dc",
  null
  
)

export default component.exports